import { useMutation } from '@tanstack/react-query';
import { authApi } from '@/data/api/authApi';
import { useSessionStore } from '@/core/auth/sessionStore';
import { queryClient } from '@/core/api/queryClient';
import { logger } from '@/core/logging/logger';
export function useLogin() {
    return useMutation({
        mutationFn: (datos) => authApi.login(datos),
        onSuccess: (data) => {
            useSessionStore.getState().setSesion({ accessToken: data.accessToken, refreshToken: data.refreshToken }, data.usuario);
        },
        onError: (err) => logger.warning('login.failed', { err: String(err) }),
    });
}
export function useLogout() {
    return useMutation({
        mutationFn: async () => {
            try {
                const refresh = useSessionStore.getState().refreshToken;
                await authApi.logout(refresh);
            }
            catch {
                // best effort: si el backend falla igual limpiamos sesión local
            }
        },
        onSettled: () => {
            useSessionStore.getState().limpiar();
            queryClient.clear();
        },
    });
}
export function useForgotPassword() {
    return useMutation({
        mutationFn: (datos) => authApi.forgotPassword(datos),
    });
}
export function useResetPassword() {
    return useMutation({
        mutationFn: (datos) => authApi.resetPassword(datos),
    });
}
